function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M4.34.25v1.894H.25v1.107h1.227l.869 11.312.003.038h9.014l.872-11.35h1.394V2.144H9.337V.25H4.34zm1.108 1.878h2.799V1.34h-2.8v.788zM2.567 3.234h8.545l-.8 10.244H3.349L2.567 3.234z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeWidth: 0.5,
  d: "M2.566 3.234h8.545l-.8 10.244H3.348L2.566 3.234zm2.881-1.106h2.8V1.34h-2.8v.788zm3.89.016V.25H4.34v1.894H.25v1.107h1.226l.87 11.311.002.04h9.014l.872-11.35h1.395V2.143H9.337z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M6.286 12.137L7.392 12.137 7.392 4.626 6.286 4.626z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeWidth: 0.5,
  d: "M6.286 12.137L7.392 12.137 7.392 4.626 6.286 4.626z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M9.268 12.17L9.674 4.695 9.676 4.653 8.613 4.596 8.571 4.594 8.165 12.069 8.164 12.111 9.226 12.168z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeWidth: 0.5,
  d: "M9.268 12.17L9.674 4.695 9.676 4.653 8.613 4.596 8.571 4.594 8.165 12.069 8.164 12.111 9.226 12.168z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M4.407 12.17L5.47 12.113 5.512 12.111 5.107 4.636 5.105 4.594 4.043 4.651 4.001 4.653 4.405 12.128z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeWidth: 0.5,
  d: "M4.407 12.17L5.47 12.113 5.512 12.111 5.107 4.636 5.105 4.594 4.043 4.651 4.001 4.653 4.405 12.128z"
}));

var SvgTrash = function SvgTrash(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrash, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trash.54a53793.svg";
export { ForwardRef as ReactComponent };